import Flatpickr from "flatpickr";
import FlatpickrI18n from 'flatpickr/dist/l10n/ja';
import moment from 'moment';

jQuery(function () {
    Flatpickr.localize(FlatpickrI18n.ja);
    let today = new Date();
    let start = moment(new Date()).add(1,'days').format("YYYY-MM-DD");
    let end = moment(new Date()).add(3,'month').format("YYYY-MM-DD");
    Flatpickr("#Date", {
        enable: [
            {
                from: start,
                to:end
            }
        ]
    });

    jQuery("#Send").click(function (e) {
        e.preventDefault();
        let send = true;
        jQuery('.req').each(function (index) {
            if (jQuery(this).val() === '') {
                send = false;
            }
        });
        if (jQuery("input[name='メール種別']:checked").val() === "ご予約"){
            jQuery('.reserve-req').each(function (index) {
                if (jQuery(this).val() === '') {
                    send = false;
                }
            });
        }
        if (!jQuery('#email').val().match(/.+@.+\..+/)) send = false;
        if (send) {
            send_mail();
        }
        else {
            jQuery(".error").addClass('show');
        }
    });

    function send_mail()
    {
        // サブミットするフォームを取得
        let f = document.forms['contact_form'];
        let action = jQuery('#MailForm').attr('action');
        if( jQuery("input[name='メール種別']:checked").val() !== "お問い合わせ" )
        {
            jQuery('.reserve-req').remove();
        }
        f.method = 'POST'; // method(GET or POST)を設定する
        f.action = action; // action(遷移先URL)を設定する
        f.submit(); // submit する
        return true;
    }

    jQuery('input[name="メール種別"]:radio').change(function () {
        if (jQuery(this).val() == "お問い合わせ") {
            jQuery('.contact').show();
            jQuery('.res').hide();
        }
        else {
            jQuery('.contact').hide();
            jQuery('.res').show();
        }
    });
});


// WEBPACK FOOTER //
// ./js/reserve.js